module.exports = __webpack_public_path__ + "static/media/img8.9ae2d6f9.jpg";